import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Careers = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const jobs = [
    { id: 1, title: 'Full Stack Java Developer', salary: '₹4L - ₹18L/year' },
    { id: 2, title: 'MERN Stack Developer', salary: '₹3.6L - ₹15L/year' },
    { id: 3, title: 'UI Developer', salary: '₹3L - ₹12L/year' },
    { id: 4, title: 'Digital Marketing Specialist', salary: '₹2.4L - ₹10L/year' },
  ];

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedJob(null);
  };

  return (
    <div>
      {/* Header Section */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: `url('/assets/img/bg/breadcumb-bg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container">
          <div className="breadcumb-content text-white py-5">
            <h1 className="breadcumb-title">Career</h1>
            <ul className="breadcumb-menu list-inline">
              <li className="list-inline-item">
                <a href="/" className="text-white">Home</a>
              </li>
              <li className="list-inline-item text-white">/ Career</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Job Grid */}
      <div className="space py-5">
        <div className="container">
          <div className="row gy-4">
            {jobs.map((job, index) => (
              <div className="col-lg-6 col-xxl-4" key={index}>
                <div className="job-post white-bg border rounded p-4 shadow-sm h-100">
                  <div className="job-content smoke-bg mb-3">
                    <h5 className="job-title">{job.title}</h5>
                    <p className="mb-0">
                      Join our team to build scalable, modern digital solutions with cutting-edge technologies.
                    </p>
                  </div>
                  <div className="job-wrapper d-sm-flex align-items-center justify-content-between text-center text-sm-start mt-3">
                    <span className="price fw-medium">
                      <i className="fa fa-money me-2"></i>{job.salary}
                    </span>
                    <Button variant="outline-primary" size="sm" onClick={() => handleApplyClick(job)}>
                      Apply Now
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Application Modal */}
      <Modal show={showModal} onHide={handleClose} centered size="md">
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="fs-5 fw-semibold">
            Apply for {selectedJob?.title}
          </Modal.Title>
        </Modal.Header>
        <Form
          action="apply.php"
          method="POST"
          encType="multipart/form-data"
        >
          <Modal.Body className="p-4">
            <Form.Control type="hidden" name="job_id" value={selectedJob?.id || ''} />

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Full Name</Form.Label>
              <Form.Control name="name" type="text" required placeholder="Enter your full name" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Email ID</Form.Label>
              <Form.Control name="email" type="email" required placeholder="Enter your email" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Mobile Number</Form.Label>
              <Form.Control name="phone" type="tel" required placeholder="Enter your mobile number" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Upload Resume</Form.Label>
              <Form.Control name="resume" type="file" required accept=".pdf,.doc,.docx" />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="bg-light px-4 py-3">
            <Button variant="outline-secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Submit Application
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default Careers;
